import { css } from 'styled-components';
import Triangle from 'assets/svgs/timeoff-triangle.svg';

export const TimeoffEventStyles = css`
  .b-sch-event-wrap.time-off-event {
    z-index: 20;
    padding-right: 0px;

    .b-sch-event {
      &:hover {
        background-color: var(--white-100);
      }
      background-color: var(--white-100);
      border-radius: 0;
    }
    .content {
      z-index: 20;
      height: 5px;
      background: url(${Triangle});
      background-repeat: round;
    }
  }
`;
